/* eslint-disable @typescript-eslint/no-explicit-any */
export const singletonPlugin = (types: string[]) => {
	return {
		name:     'singletonPlugin',
		document: {
			newDocumentOptions: (prev: any[], { creationContext }: any) => {
				if (creationContext.type === 'global') {
					return prev.filter(templateItem => !types.includes(templateItem.templateId));
				}

				return prev;
			},
			actions: (prev: any[], { schemaType }: any) => {
				if (types.includes(schemaType)) {
					return prev.filter(({ action }) => action !== 'duplicate');
				}

				return prev;
			},
		},
	};
};